<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!hideBack">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{titulo}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <!-- SOMENTE PARA APP_CAD_INICIO -->
  <div
    class="login-div"
    *ngIf="tipo == 'APP_CAD_INICIO' && !facebook && !esconderFacebook && erro_email"
  >
    <button
      ion-button
      block
      class="btn-prover"
      type="button"
      (click)="buscarDadosFacebook()"
    >
      <ion-icon name="logo-facebook"></ion-icon>
      {{'Vincular Facebook' | translate}}
    </button>
  </div>

  <ion-card-content class="remove-card">
    <!-- SOMENTE PARA APP_CAD_INICIO -->
    <h3 class="error-email" *ngIf="tipo == 'APP_CAD_INICIO' && erro_email">
      {{'Identificamos que já há um cadastro com seu e-mail. Caso não lembre sua
      senha, utilize o menu ' | translate}} "<a (click)="esqueceuSenha();"
        >{{'Esqueceu sua senha?' | translate}}</a
      >" {{'para resgatá-la' | translate}}.
    </h3>

    <h3 class="error-email" *ngIf="tipo == 'APP_CAD_INICIO' && erro_cpf">
      {{'Identificamos que já há um cadastro com seu CPF. Caso não lembre sua
      senha, utilize o menu ' | translate}} "<a (click)="esqueceuSenha();"
        >{{'Esqueceu sua senha?' | translate}}</a
      >" {{'para resgatá-la' | translate}}.
    </h3>

    <dynamic-form
      *ngIf="loaded && !erro_email && !erro_cpf"
      [fields]="campos"
      (submit)="submit($event)"
    >
    </dynamic-form>
  </ion-card-content>
</ion-content>
